import { useEffect, useState } from 'react';

/**
 * returns an object with width property that is updated on ref component or window resize
 * @param  {React.RefObject<HTMLDivElement| null>} myRef
 * @returns {width}
 */
export const useResize = (myRef: React.RefObject<HTMLDivElement | null>): { width: number } => {
    const [width, setWidth] = useState(1);
    useEffect(() => {
        const handleResize = () => {
            if (myRef.current) {
                const { current } = myRef;
                const boundingRect = current.getBoundingClientRect();
                const { width } = boundingRect;
                setWidth(width);
            }
        };

        handleResize();
        // Add event listener
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myRef]);
  
    return { width };
};
